import KeywordHighlight from './KeywordHighlight'
import classNames from 'classnames'
import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class SelectedTranscriptHighlight extends Component {
  static propTypes = {
    endOffset: PropTypes.number,
    hasTimestamps: PropTypes.bool,
    searchHighlights: PropTypes.array,
    startOffset: PropTypes.number,
    transcript: PropTypes.string
  }

  static defaultProps = {
    hasTimestamps: false,
    searchHighlights: []
  }

  componentDidMount() {
    this.scrollToSelection()
  }

  scrollToSelection() {
    const node = findDOMNode(this)
    node.scrollTop = this.quoteSelection.offsetTop - node.offsetTop
  }

  highlightText(text) {
    const tokens = this.props.searchHighlights.reduce((memo, highlight) => {
      return memo.concat(highlight.tokens)
    }, [])

    return <KeywordHighlight text={text} tokens={tokens} />
  }

  render() {
    const { endOffset, hasTimestamps, startOffset, transcript } = this.props
    const slicePoint = endOffset === 0 ? 0 : endOffset + 1

    const hasTimestampsClass = classNames({
      'grey-reg-i': hasTimestamps
    })

    return (
      <div>
        <span>{this.highlightText(transcript.slice(0, startOffset))}</span>
        <span
          ref={quoteSelection => (this.quoteSelection = quoteSelection)}
          className="qv-quote-selection"
        >
          {this.highlightText(transcript.slice(startOffset, slicePoint))}
        </span>
        <span className={hasTimestampsClass}>
          {this.highlightText(transcript.slice(slicePoint))}
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/SelectedTranscriptHighlight.js